import { Flex } from '@applyboard/crystal-ui';

import { ProgramDetailsHeading } from '../components/ProgramDetailsHeading';
import { ProgramInformation } from '../components/ProgramInformation';

export function MobileLayout() {
  return (
    <Flex p={4} gap={4} direction="column">
      <ProgramDetailsHeading />
      <ProgramInformation />
    </Flex>
  );
}
